export const reloadState = {
  // todo: 'TODO',
  doing: 'DOING',
  done: 'DONE',
};